/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type { GetApiSocietaSmtpConfigurationsQueryResponse } from '../models/GetApiSocietaSmtpConfigurations.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiSocietaSmtpConfigurationsQueryResponseSchema } from '../zod/getApiSocietaSmtpConfigurationsSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiSocietaSmtpConfigurationsQueryKey = () =>
  [{ url: '/api/societa/smtp-configurations' }] as const;

export type GetApiSocietaSmtpConfigurationsQueryKey = ReturnType<
  typeof getApiSocietaSmtpConfigurationsQueryKey
>;

/**
 * {@link /api/societa/smtp-configurations}
 */
export async function getApiSocietaSmtpConfigurations(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiSocietaSmtpConfigurationsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/societa/smtp-configurations`,
    ...requestConfig,
  });
  return getApiSocietaSmtpConfigurationsQueryResponseSchema.parse(res.data);
}

export function getApiSocietaSmtpConfigurationsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiSocietaSmtpConfigurationsQueryKey();
  return queryOptions<
    GetApiSocietaSmtpConfigurationsQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiSocietaSmtpConfigurationsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiSocietaSmtpConfigurations(config);
    },
  });
}

/**
 * {@link /api/societa/smtp-configurations}
 */
export function useGetApiSocietaSmtpConfigurations<
  TData = GetApiSocietaSmtpConfigurationsQueryResponse,
  TQueryData = GetApiSocietaSmtpConfigurationsQueryResponse,
  TQueryKey extends QueryKey = GetApiSocietaSmtpConfigurationsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiSocietaSmtpConfigurationsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiSocietaSmtpConfigurationsQueryKey();

  const query = useQuery(
    {
      ...getApiSocietaSmtpConfigurationsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
